export default "__VITE_ASSET__BlcLHJIy__"